import axios from 'axios';
const API_URL = process.env.REACT_APP_API;

const buildQuery = (filters?: Record<string, any>) => {
  if (!filters) return '';

  const params = new URLSearchParams();

  Object.entries(filters).forEach(([key, value]) => {
    if (value !== undefined && value !== null && value !== '') {
      params.append(key, String(value));
    }
  });

  return params.toString() ? `?${params}` : '';
};

export async function getAllCuentas() {
  const response = await axios.get(
    `${API_URL}catalogos/account?limit=1000&page=1`,
  );
  const data = response.data.doc.data;
  return data;
}

export async function getBalanceYear() {
  const response = await axios.get(`${API_URL}operation/activity/current/year`);
  const data = response.data.doc.data;
  return data;
}

export async function getBalanceMonth() {
  const response = await axios.get(
    `${API_URL}operation/activity/current/month`,
  );
  const data = response.data.doc.data;
  return data;
}

export async function getBalanceWeek() {
  const response = await axios.get(`${API_URL}operation/activity/current/week`);
  const data = response.data.doc.data;
  return data;
}

interface GetOffersParams {
  init_date?: string;
  end_date?: string;
}

interface OfferItem {
  offer_name: string;
  count: number;
  percentage: number;
}

export interface OffersOperationResponse {
  activations: OfferItem[];
  portabilities: OfferItem[];
  recharges: OfferItem[];
}

export async function getOffersOperation(
  params: GetOffersParams,
): Promise<OffersOperationResponse> {
  const response = await axios.get(`${API_URL}dashboard/operation-offers`, {
    params,
  });

  return (
    response?.data?.doc?.data ?? {
      activations: [],
      portabilities: [],
      recharges: [],
    }
  );
}

export async function getStatusStock(filters: any) {
  const params = new URLSearchParams();
  if (!filters) {
    return false;
  }
  if (filters.init_date) params.set('init_date', filters.init_date);
  if (filters.end_date) params.set('end_date', filters.end_date);
  const response = await axios.get(
    `${API_URL}dashboard/stock-status-movements?${params}`,
  );
  const data = response.data.doc.data;
  return data;
}

export async function getOperationWeb(filters: any) {
  const params = new URLSearchParams();
  if (!filters) {
    return false;
  }
  if (filters.init_date) params.set('init_date', filters.init_date);
  if (filters.end_date) params.set('end_date', filters.end_date);
  const response = await axios.get(
    `${API_URL}dashboard/operation-web?${params}`,
  );
  const data = response.data.doc.data;
  return data;
}

export async function getOperationApp(filters: any) {
  const params = new URLSearchParams();
  if (!filters) {
    return false;
  }
  if (filters.init_date) params.set('init_date', filters.init_date);
  if (filters.end_date) params.set('end_date', filters.end_date);
  const response = await axios.get(
    `${API_URL}dashboard/operation-app?${params}`,
  );
  const data = response.data.doc.data;
  return data;
}

export async function getBalanceChart(filters?: Record<string, any>) {
  try {
    const query = buildQuery(filters);

    const response = await axios.get(
      `${API_URL}dashboard/comparation-operation${query}`,
    );

    return response.data?.doc?.data ?? [];
  } catch (error) {
    console.error('Error getBalanceChart:', error);
    throw error;
  }
}

export async function getBalanceAprov() {
  try {
    const response = await axios.get(`${API_URL}dashboard/provisioning`);

    return response.data?.doc?.data ?? {};
  } catch (error) {
    console.error('Error getBalanceAprov:', error);
    throw error;
  }
}

